import * as React from "react";
import type { SVGProps } from "react";
const SvgWhatsappNegative = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      fill="#1D1D1D"
      d="m2.503 17.5 1.014-3.726a7.5 7.5 0 1 1 2.71 2.71zm4.79-11.019a.7.7 0 0 0-.278.075 1 1 0 0 0-.22.171c-.09.085-.141.158-.196.23-.277.36-.427.803-.424 1.258.002.367.098.725.248 1.06.306.676.811 1.393 1.478 2.056.16.16.317.32.486.47a7.1 7.1 0 0 0 2.88 1.534l.427.065c.138.008.277-.002.416-.01.219-.01.432-.07.625-.173q.148-.075.288-.165 0 .002.093-.067c.101-.075.164-.128.248-.216a.9.9 0 0 0 .157-.226 2 2 0 0 0 .141-.55c.018-.149.013-.23.01-.28-.002-.08-.069-.163-.142-.199l-.436-.195s-.653-.285-1.051-.466a.4.4 0 0 0-.133-.031.36.36 0 0 0-.283.095v-.001c-.004 0-.054.043-.597.7a.26.26 0 0 1-.275.097 1 1 0 0 1-.144-.05l-.189-.081-.004-.002a4.5 4.5 0 0 1-1.177-.75c-.094-.082-.182-.172-.272-.26a4.7 4.7 0 0 1-.765-.95l-.044-.071a.7.7 0 0 1-.077-.154c-.028-.11.046-.199.046-.199s.182-.2.267-.307q.105-.136.197-.28c.089-.143.116-.289.07-.402a62 62 0 0 0-.651-1.531c-.044-.1-.176-.173-.295-.187l-.121-.012a3 3 0 0 0-.303.003z"
    />
  </svg>
);
export default SvgWhatsappNegative;
